import { render, staticRenderFns } from "./card.vue?vue&type=template&id=78322c72&scoped=true&"
var script = {}
import style0 from "./card.vue?vue&type=style&index=0&id=78322c72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78322c72",
  null
  
)

export default component.exports